import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tarifas-coordinador',
  templateUrl: './tarifas-coordinador.component.html',
  styleUrls: ['./tarifas-coordinador.component.css']
})
export class TarifasCoordinadorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
